import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87723150"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "tw-flex tw-rounded-[6px] tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-w-[100%] notes-input-field" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 3,
  class: "tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
}

import { computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import VRuntimeTemplate from "vue3-runtime-template";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { successStatusCodes } from "@/utils/constants";
import { putChecklistStatus } from "@/services/assessment";
import { showErrorAPI, showToastMessage } from "@/services/apiRoutes";
import { ToastVariant } from "@/interfaces/common/IToastMessage";
import { Checklist } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'textAreaRoadmap',
  props: {
  isEditStatus: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    required: true,
  },
  keyField: {
    type: String,
    required: true,
  },
  itemInvalids: {
    type: Array,
    default: () => [],
  },
  customClass: {
    type: String,
    default: "",
  },
},
  emits: ["edit-notes", "update-notes"],
  setup(__props, { emit }) {

const props = __props;





const autoTextarea = ref<HTMLTextAreaElement | null>(null);
const value = ref(props.item[props.keyField] || "");

const roadMapErrorData = computed(() => {
  return store.state.Sharing.roadMapErrorData;
});

const isErrorChecklistName = computed(() => {
  return (
    (value.value === "" && props.keyField === "checklistGroupName") ||
    (props.itemInvalids || []).includes(props.item.checklistId)
  );
});

watch(
  () => isErrorChecklistName.value,
  (newValue) => {
    const errorData = roadMapErrorData.value || [];

    if (
      newValue &&
      !roadMapErrorData.value?.includes(props.item.checklistGroupId)
    ) {
      errorData.push(props.item.checklistGroupId);
    }
    if (
      !newValue &&
      roadMapErrorData.value?.includes(props.item.checklistGroupId)
    ) {
      const index = errorData.indexOf(props.item.checklistGroupId);
      if (index > -1) {
        errorData.splice(index, 1);
      }
    }

    store.commit("Sharing/SET_ROAD_MAP_ERROR_DATA", errorData);
  },
  { immediate: true },
);

watch(
  () => props.item[props.keyField],
  (newValue) => {
    if (newValue !== value.value) {
      value.value = newValue;
    }
  },
  { immediate: true },
);

watch(
  () => props.isEditStatus,
  (newValue) => {
    if (newValue) {
      autoResize();
    }
  },
);

onMounted(() => {
  if (props.isEditStatus) {
    autoResize();
  }
});

const onChangeStatusEdit = async () => {
  await onSaveData();
  emit("edit-notes");
};

const autoResize = (e?) => {
  if (
    e &&
    props.keyField === "checklistHistoryNotes" &&
    isErrorChecklistName.value
  ) {
    emit("edit-notes", e.target.value);
  }
  setTimeout(() => {
    if (autoTextarea.value) {
      autoTextarea.value.style.height = "44px"; // Reset height
      autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
    }
  }, 10);
};
const isCallApi = ref(false);
let dataRevert;

const onSaveData = async () => {
  try {
    value.value = value.value?.trim();
    if (props.keyField === "checklistHistoryNotes") {
      if (
        value.value === props.item[props.keyField] ||
        (!value.value && !props.item[props.keyField])
      )
        return;
      if (value.value === "") emit("edit-notes", value.value);
      else {
        isCallApi.value = true;
        const res = await putChecklistStatus(props.item.checklistId, {
          checklistStatusNotes: value.value,
          checklistStatusId: props.item.checklistStatusId,
        });
        if (res.status === successStatusCodes.OK) {
          emit("update-notes", value.value);
        } else {
          value.value = props.item[props.keyField];
        }
      }
      return;
    }
    if (
      value.value === props.item[props.keyField] ||
      isErrorChecklistName.value ||
      (!value.value && !props.item[props.keyField])
    ) {
      return;
    }

    const params = {
      checklistGroupId: props.item.checklistGroupId,
      ...(props.keyField === "checklistGroupActions"
        ? { actions: value.value }
        : {
            name: value.value,
          }),
    };
    isCallApi.value = true;
    dataRevert = props.item[props.keyField];
    const res = await store.dispatch("Sharing/updateRoadMapItemData", params);
    if (!res) {
      value.value = dataRevert;
    }
  } catch (error: any) {
    showErrorAPI(error, Checklist.updateChecklistShared);
  } finally {
    isCallApi.value = false;
  }
};

const handleKeyDown = (event: KeyboardEvent) => {
  if (props.keyField === "checklistHistoryNotes") {
    return;
  }
  if (event.key === "Enter" && !event.shiftKey) {
    event.preventDefault();
    onChangeStatusEdit();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${
      __props.keyField === 'checklistHistoryNotes' ? 'tw-w-full' : ''
    } tw-flex tw-items-start tw-w-full tw-relative`)
  }, [
    (!__props.isEditStatus && __props.keyField === 'checklistHistoryNotes')
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["tw-text-[13px] tw-text-[#231F20] tw-whitespace-pre-line", __props.customClass]),
          innerHTML: __props.item[__props.keyField] || ''
        }, null, 10, _hoisted_1))
      : _createCommentVNode("", true),
    (!__props.isEditStatus && __props.keyField !== 'checklistHistoryNotes')
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["tw-text-[13px] tw-text-[#231F20] tw-whitespace-pre-line", __props.customClass])
        }, _toDisplayString(__props.item[__props.keyField]), 3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("span", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        id: `roadmap-do-what-input-${__props.item.checklistGroupId}`,
        ref_key: "autoTextarea",
        ref: autoTextarea,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        type: "text",
        class: _normalizeClass([
          'input-field tw-border tw-border-solid tw-outline-none tw-w-full tw-p-[12px] tw-text-[13px] tw-rounded-md tw-font-normal',
          isErrorChecklistName.value ? '!tw-border-[#f7553c]' : 'tw-border-[#EFF0F1]',
          isCallApi.value ? '!tw-pr-[45px]' : '',
        ]),
        onKeydown: _cache[1] || (_cache[1] = (e) => handleKeyDown(e)),
        onFocusout: _cache[2] || (_cache[2] = () => onSaveData()),
        onInput: autoResize
      }, null, 42, _hoisted_3), [
        [_vModelText, value.value]
      ])
    ], 512), [
      [_vShow, __props.isEditStatus]
    ]),
    (isErrorChecklistName.value)
      ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
          key: 2,
          class: _normalizeClass({ 'is-invalid': isErrorChecklistName.value })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VRuntimeTemplate), {
              template: _unref(getComponentUiText)('app-common-form-value-required-error-1')
            }, null, 8, ["template"])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (isCallApi.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(LottieAnimation), {
            ref: "anim",
            "animation-data": _unref(ProgressAnimation),
            "auto-play": true,
            loop: true
          }, null, 8, ["animation-data"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})